// TODO: Convert this file to TS once we're no longer using it in JS classes.

/**
 * @typedef {Object} IconOptions
 * @property {string} [classes] (Optional) A string of one or more classnames, separated by spaces
 * @property {string} [title] (Optional) Text that describes the intent of the icon
 */

export class Icon {
  /** @param {string} name The `id` of the icon symbol to reference within the icon set */
  /** @param {IconOptions} options Optional classes or title for this Icon instance */
  constructor(name, options = {}) {
    const { classes, title } = options
    this.classes = typeof classes === 'string' && classes.length ? classes.split(' ') : []
    this.id = `icon-${crypto.randomUUID().split('-').at(0)}`
    this.name = name
    this.title = title
  }

  // Getters

  get hasClasses() {
    return this.classes.length > 0
  }

  get hasTitle() {
    return typeof this.title === 'string' && this.title.length > 0
  }

  get titleId() {
    return `${this.id}-title`
  }

  // Public methods

  asElement() {
    const svg = this.#svgElement()
    if (this.hasTitle) svg.appendChild(this.#titleElement())
    svg.appendChild(this.#useElement())
    return svg
  }

  asString() {
    return this.asElement().outerHTML
  }

  // Private methods

  /**
   * Generate an element in the SVG namespace instead of the HTML namespace
   * @property {string} tagName
   **/
  #createSvgTag(tagName) {
    return document.createElementNS('http://www.w3.org/2000/svg', tagName)
  }

  #svgElement() {
    /** @type {SVGSVGElement} */
    const tag = this.#createSvgTag('svg')

    tag.classList.add('icon')
    tag.setAttribute('height', '24')
    tag.setAttribute('viewBox', '0 0 24 24')
    tag.setAttribute('width', '24')

    if (this.hasTitle) {
      tag.setAttribute('aria-labelledby', this.titleId)
      tag.setAttribute('role', 'img')
    } else {
      tag.setAttribute('aria-hidden', true)
      tag.setAttribute('role', 'presentation')
    }

    if (this.classes) {
      tag.classList.add(...this.classes)
    }

    return tag
  }

  #titleElement() {
    /** @type {SVGTitleElement} */
    const tag = this.#createSvgTag('title')
    tag.id = this.titleId
    tag.innerText = this.title
    return tag
  }

  #useElement() {
    /** @type {SVGUseElement} */
    const tag = this.#createSvgTag('use')
    tag.setAttribute('href', `#${this.name}`)
    return tag
  }
}
